"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreditLimit = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const processName = "ADABYRON-API";
const normalizer = (response) => {
    let res = null;
    if (response && response.data) {
        res = {};
        // Credit Limit
        if (response.data.clientInfo && response.data.clientInfo.creditLimit) {
            res.creditLimit = {
                tpvp: response.data.clientInfo.creditLimit.totalPVP,
                mpvp: response.data.clientInfo.creditLimit.monthlyPVP,
            };
        }
        // Recom
        if (response.data.recommendation) {
            const data = response.data.recommendation;
            res.userRecom = {
                fidelizacion: data.fidelizacion
            };
            if (data.comercial && data.comercial.verticales) {
                const { verticales } = data.comercial;
                if (Object.keys(verticales) && Object.keys(verticales).length > 0) {
                    Object.keys(verticales).forEach(vertical => {
                        res.userRecom[vertical] = verticales[vertical];
                    });
                }
            }
        }
    }
    return res;
};
function getCreditLimit(userIdPartyHash) {
    const idRequest = (0, utils_monitoring_get_uuid_1.default)();
    let sonda = new utils_monitoring_sonda_1.default({
        eventName: "CREDIT.GET_CREDIT_LIMIT",
        context: {},
        uniqueId: idRequest,
        origin: processName,
    });
    let URL_API = "https://layer.col.movistar.es/api/movistar-layer/client/perso/v2/info/get";
    const request = new utils_fetch_1.default({
        method: "POST",
        endpoint: URL_API,
        data: { clientPartyId: userIdPartyHash },
        headers: {},
        onSuccess: (response) => {
            let dataNormalized = null;
            dataNormalized = normalizer(response);
            return dataNormalized;
        },
        sonda,
    });
    return request.makeRequest();
}
exports.getCreditLimit = getCreditLimit;
exports.default = getCreditLimit;
//# sourceMappingURL=index.js.map